import { allHtmlParsers, parseChildren } from '@utils/ast';
import { iframeComponentParsers } from './component.iframe.js';
import { imageComponentParsers } from './component.image.js';
import { mediaComponentParsers } from './component.media.js';
import { textComponentParsers } from './component.text.js';
import { textComponentDivParser } from './component.text.div.js';
import { textComponentGlossaryWordParsers } from './component.text.glossary-words.js';
import { textComponentLinkParsers } from './component.text.links.js';

const parseTextComponentHtmlNode = (node, context) => {
  const attributes = Object.fromEntries(
    Array.from(node.attributes).map((it) => [it.nodeName, it.nodeValue]).filter((it) => it[1] !== null)
  );
  const children = parseChildren(
    node,
    {
      ...textComponentHtmlParsers,
      ...imageComponentParsers,
      ...iframeComponentParsers,
      ...mediaComponentParsers,
      ...textComponentParsers,
      ...textComponentLinkParsers,
      ...textComponentGlossaryWordParsers,
      ...textComponentDivParser
    },
    context.depth + 1
  );
  return {
    nodeType: "text-component.html",
    tagName: node.tagName.toLowerCase(),
    attributes: Object.keys(attributes).length > 0 ? attributes : void 0,
    children: children.length > 0 ? children : void 0
  };
};
const textComponentHtmlParsers = Object.fromEntries(
  Object.keys(allHtmlParsers).map(
    (key) => [key, parseTextComponentHtmlNode]
  )
);

export { parseTextComponentHtmlNode, textComponentHtmlParsers };
//# sourceMappingURL=component.text.html.js.map
